import { useMemo } from "react";
import { useLocation } from "react-router";
import { EntityTypes } from "types";

interface RouteIDs {
  segment1: { entityType: EntityTypes; entityID: number };
  segment2: { entityType: EntityTypes; entityID: number };
  segment3: { entityType: EntityTypes; entityID: number };
}

export const useRouteIDs = (): RouteIDs => {
  const { pathname } = useLocation();

  const segments = useMemo(() => {
    const splitPath = pathname.split("/");
    const segments: RouteIDs = {
      segment1: { entityType: EntityTypes.None, entityID: 0 },
      segment2: { entityType: EntityTypes.None, entityID: 0 },
      segment3: { entityType: EntityTypes.None, entityID: 0 },
    };
    for (let i = 1; i < splitPath.length; i += 2) {
      if (i === 1) {
        segments.segment1 = {
          entityType: splitPath[i]
            .replace(/-/g, "_")
            .toLowerCase() as EntityTypes,
          entityID: parseInt(splitPath[i + 1]),
        };
      } else if (i === 3) {
        segments.segment2 = {
          entityType: splitPath[i]
            .replace(/-/g, "_")
            .toLowerCase() as EntityTypes,
          entityID: parseInt(splitPath[i + 1]),
        };
      } else if (i === 5) {
        segments.segment3 = {
          entityType: splitPath[i]
            .replace(/-/g, "_")
            .toLowerCase() as EntityTypes,
          entityID: parseInt(splitPath[i + 1]),
        };
      }
    }
    return segments;
  }, [pathname]);

  return segments;
};
